import { FC } from 'react';

import { CalcHeader } from './components/CalcHeader/CalcHeader';
import { CalcContent } from './components/Content/CalcContent';

import styles from './Calc.module.scss';

export const Calc: FC = () => {
	return (
		<div className={styles.container}>
			<CalcHeader />
			<CalcContent />
		</div>
	);
};
